import QorusClient from "@/api/clients/QorusClient";
import { Order } from "@/models/order";
import { Page } from "@/models/page";
import { AxiosRequestConfig } from "axios";

/**
 *  Qorus API about orders
 */
export default class OrderApi {
  static of(): OrderApi {
    return new OrderApi();
  }

  getAll(query): Promise<Page<Order>> {
    //v1/products?category=<category>
    //v1/products/categories/<category>
    const defaultSort = "paymentDate.desc";
    const sort = query.sort?.split(".")[0] || defaultSort.split(".")[0];
    const sortOrder = query.sort?.split(".")[1] || defaultSort.split(".")[1];
    return QorusClient.client.get("orders", {
      params: {
        size: query.itemsPerPage || 1,
        page: query.page - 1 || 0,
        sort: sort + "," + sortOrder,
      },
    });
  }

  getByCartUuid(uuid: string) { /* TODO */
      return QorusClient.client.get("orders/uuid/" + uuid)
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
  }

  getByReference(orderReference: string) { /* TODO */
      return QorusClient.client.get("orders/reference/" + orderReference)
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
  }

  AddEmpowermentCard(shoppingCartId, customMessage): Promise<any> | undefined {
      return QorusClient.client.post("empowerment/order/setCustomCard", { customCardMessage: customMessage })
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
  }

  validEmpowerment(shoppingCartId): Promise<any> | undefined {
      return QorusClient.client.get("empowerment/order/" + shoppingCartId + "/validate").then(
        (data) => {
          return data;
        },
        (data) => {
          throw data;
        },
      );
  }

  getCustomerOrders(query: any): Promise<Page<Order>> | undefined {
      const sort = query.sort?.split(".")[0] || "paymentDate";
      const sortOrder = query.sort?.split(".")[1] || "desc";
      const axiosRequestConfig: AxiosRequestConfig = {
        params: {
          size: query.itemsPerPage || 10,
          page: query.page - 1 || 0,
          sort: sort + "," + sortOrder,
        },
      };
      return QorusClient.client.get("orders/customer", axiosRequestConfig)
        .then(
          (data) => {
            return data;
          },
          (data) => {
            throw data;
          },
        );
  }

  getInvoice(orderId) {
    const axiosRequestConfig: AxiosRequestConfig = {
      responseType: "arraybuffer",
    };

    return QorusClient.client.get("order-invoices/pdf/order/" + orderId, axiosRequestConfig)
      .then(
        (data) => {
          return data;

        },
        (data) => {
          throw data;
        },
      );
  }

  cancel() { /* TODO */
  }
}